window.addEventListener('DOMContentLoaded', function () {
  jQuery(function ($) {
    /**
     * @type {MapRenderer}
     */
    let map;

    let mapWrapper = document.querySelector('.map-wrapper');
    if (!mapWrapper) return;

    /**
     *
     * @param {Object} center
     *
     * @param {Number} center.lat
     * @param {Number} center.lng
     * @returns
     */
    async function initMap(center) {
      // Don't re-initialize the map if it's already initialized
      if (map) map.getMap().remove();

      map = new MapRenderer({
        container: mapWrapper,
        geojson: window.theme.campGeojsonData,
        center: center,
        zoom: 18,
        maxZoom: 18,
        mapId: 'LOCATION_MAP',
      });
    }

    let lat = parseFloat(mapWrapper.dataset.lat),
      lng = parseFloat(mapWrapper.dataset.lng);

    let center = { lat, lng };

    initMap(center);
  });
});
